import React from 'react';

import CloseIcon from '@mui/icons-material/Close';

const EmailChip = ({email, isInvalid, isDuplicate, onRemove}) => {
    const baseClass = 'inline-flex items-center gap-1 px-2 py-1 rounded-menu text-sm max-w-[250px]';
    const colorClass = isInvalid
        ? 'bg-[color-mix(in_srgb,var(--leavedeletenew-normal-color)_10%,transparent)] text-leavedeletenew-normal border border-leavedeletenew-normal'
        : isDuplicate
            ? 'bg-[color-mix(in_srgb,var(--caution-warning-color)_10%,transparent)] text-[var(--caution-warning-color)] border border-[var(--caution-warning-color)]'
            : 'bg-panels-normal text-main-normal border border-panels-normal';

    return (
        <span className={`${baseClass} ${colorClass}`}>
            <span className="truncate">{email}</span>
            <CloseIcon
                style={{fontSize: 14, cursor: 'pointer', flexShrink: 0}}
                onClick={onRemove}
            />
        </span>
    );
};

export default EmailChip;
